function fn_comp_visual() {
    var $fn = $(".comp_visual"),
        $slider = $fn.find("[data-background-slider]"),
        $data_slider_autoplay = $slider.data("background-slider");

    // $("#asd").beforeImgLoad(function(width, height){
    //     console.log(width,height);
    // });

    if ($slider.children().length > 1) {
        $slider.slick({
            infinite: true,
            speed: 1000,
            fade: true,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: $data_slider_autoplay,
            arrows: false,
            pauseOnHover: false,
            dots: false
        });
        $slider.on('afterChange', function(){
            $(this).find(".slick-active").find("img").addClass("lazyload");
        });
    }

    $fn.find("[data-scroll-down]").on("click", function() {
        var $offset;
        if ($(window).width() < 1170) {
            $offset = 57.6;
        } else {
            $offset = 64;
        }

        $('html, body').animate({
            scrollTop: $fn.next().offset().top - $offset
        }, 500);
    });
}